<template>
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="formObj"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
        ref="formRefs"
      >
      <el-form-item label="结算群组" prop="managementFeeGroupIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.managementFeeGroupIds"
            placeholder="请选择结算群组"
          >
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算师傅" prop="masterWorkerIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.masterWorkerIds"
            placeholder="请选择结算师傅"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyIdList">
          <el-select
            multiple
            filterable
            v-model="formObj.companyIdList"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上游订单号" prop="reserve2">
          <el-input
            type="text"
            placeholder="请输入上游订单号"
            v-model="formObj.reserve2"
          ></el-input>
        </el-form-item>
        <el-form-item label="主机厂编号" prop="pileModel">
          <el-input
            type="text"
            placeholder="请输入主机厂编号"
            v-model="formObj.pileModel"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题编号" prop="pileModel">
          <el-input
            type="text"
            placeholder="请输入问题编号"
            v-model="formObj.reserve5"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            type="text"
            placeholder="请输入客户名称"
            v-model="formObj.customerName"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            type="text"
            placeholder="请输入手机号"
            v-model="formObj.phone"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getTableData(true)">查询</el-button>
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="container_table">
        <div class="submit_btn">
          <el-button
            type="primary"
            size="small"
            :disabled="multipleSelection.length <= 0"
            @click="submitTable"
            >提交</el-button
          >
        </div>
        <BaseTable
          :tableData="tableData"
          :columns="columns"
          :showPagination="true"
          :isSelection="true"
          :max-height="800"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
        ></BaseTable>
      </div>

      <el-dialog
        title="请选择结算批次名称"
        :visible.sync="dialogSubmit"
        append-to-body
        :close-on-click-modal="false"
        width="600px"
        @close="closeDialog"
      >
      <el-form :model="dialogForm" ref="dialogFormRefs" :rules="dialogRules" label-width="110px" style="padding: 0 20px;" size="small">
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select
            filterable
            style="width: 100%"
            v-model="dialogForm.settlementBatchName"
            placeholder="请输入或选择结算批次名称（只有未关联结算单的批次可选）"
            allow-create
            default-first-option
          >

          <!-- :disabled="item.disabled"  -->
            <el-option
              v-for="(item,index) in settlementList"
              :key="index"
              :label="item.settlementBatchName"
      
              :value="item.settlementBatchName"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button type="primary" size="small" @click="submitSettlement"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 未归属师傅提示弹窗 -->
      <UnassignedInstallerDialog
        :visible.sync="dialogUnassignedInstaller"
        :installer-list="unassignedInstallerList"
      />
    </div>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import UnassignedInstallerDialog from "./UnassignedInstallerDialog.vue";
import moment from 'moment';
export default {
  name: "TobeConfirmed",
  components: {
    BaseTable,
    UnassignedInstallerDialog,
  },
  props: {
    dialogisClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formObj: {
        companyIdList: [],
        masterWorkerIds: [],
        reserve2: "",
        pileModel: "",
        reserve5: "",
        customerName: "",
        phone: "",
        managementFeeGroupIds: [],
      },
      dialogForm: {
        settlementBatchName: "",
      },
      dialogRules: {
        settlementBatchName: [
          { required: true, message: "请选择结算批次名称", trigger: "change" },
        ],
      },
      pageSize: 50,
      pageNum: 1,
      total: 0,
      tableData: [],
      multipleSelection: [],
      columns: [
        {
          prop: "pileModel",
          label: "主机厂编号",
          width: 145,
          showOverflowTooltip: true,
        },
        {
          prop: "reserve2",
          label: "上游订单号",
        },
        {
          prop: "companyName",
          label: "所属公司",
        },
        {
          prop: "deviceBrandName",
          label: "品牌",
        },
        {
          prop: "modelName",
          label: "车型",
        },
        {
          prop: "provinceName",
          label: "省",
        },
        {
          prop: "cityName",
          label: "市",
        },
        {
          prop: "areaName",
          label: "区县",
          showOverflowTooltip: true,
        },
        {
          prop: "customerName",
          label: "客户名称",
        },
        {
          prop: "phone",
          label: "手机号",
        },
        {
          prop: "masterWorkerName",
          label: "师傅",
        },
        {
          prop: "installFinishTime",
          label: "完工时间",
          formatter:this.dateFormat,
          width: 130,
        },
        {
          prop: "",
          label: "安装费用",
        },
      ],
      companyDrownList: this.$store.state.company,
      allUserList: this.$store.state.allUserList || [],
      dialogSubmit: false,
      settlementList: [],
      groupList: [],
      dialogUnassignedInstaller: false,
      unassignedInstallerList: []
    };
  },
  watch: {
    dialogisClose:{
      handler: function (val) {
          if (val) {
          this.getTableData(true);
          this.querySettlementList();
          this.getGroupList();
          this.loadAllUserList();
        } else {
          this.reset();
          this.tableData = [];
          this.pageNum = 1;
          this.pageSize = 10;
          this.total = 0;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    getGroupList(){
      this.axios({
        method: "get",
        url: "/pending-settlement-order/listSettlementGroup",
      }).then((res) => {
        this.groupList = res.data.data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData(false);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData(false);
    },
    getTableData(flag) {
      if (flag) {
        this.pageNum = 1;
        this.pageSize = 10;
      }
      this.axios({
        method: "post",
        url: "/pending-settlement-order/select-order",
        data: {
          size: this.pageSize,
          page: this.pageNum,
          queryInfoParams: this.formObj,
        },
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    submitTable() {
      this.dialogSubmit = true;
    },
    querySettlementList() {
      //结算批次下拉
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementNameAndStatus",
      }).then((res) => {
        this.settlementList = res.data.data;
      });
    },
    reset() {
      this.$refs.formRefs.resetFields();
    },
    submitSettlement(){
      this.$refs.dialogFormRefs.validate((valid) => {
        if (valid) {
          const data = {
            settlementBatchName: this.dialogForm.settlementBatchName,
            orderList: [],
          };
          this.multipleSelection.forEach((item) => {
            const orderItem = {
              brandId: item.deviceBrandId,
              carModelId: item.modelId,
              companyId: item.companyId,
              contactInfo: item.phone,
              customerName: item.customerName,
              id: '',
              installFee: '', //没有 安装费用
              installerId: item.masterWorker,
              mainOrderNo: item.pileModel,
              managementFee: '',  // 群组管理费
              orderId: item.id,
              settlementOrderId: '',
              source: true,
              upstreamOrderNo: item.reserve2,
              vin: item.frameNo,
            }
            data.orderList.push(orderItem);
          });

          // 直接提交，成功后检测
          this.doSubmitSettlement(data);
        } else {
          return false;
        }
      });
    },
    doSubmitSettlement(data) {
      this.axios({
        method: "post",
        url: "/pending-settlement-order/add",
        data
      }).then((res) => {
        if(res.data.code == 200 && res.data.data.saveResult){
          this.$message.success(res.data.message);
          this.dialogSubmit = false;
          this.dialogForm.settlementBatchName = '';
          
          // 保存成功后，检查是否有未归属的师傅
          if(res.data.data && res.data.data.unassignedInstallerList && res.data.data.unassignedInstallerList.length > 0){
            // 有未归属的师傅，显示弹窗
            this.unassignedInstallerList = res.data.data.unassignedInstallerList;
            this.dialogUnassignedInstaller = true;
          }
          
          this.$emit('close-dialog', false);
          this.reset()
        }else if(res.data&&res.data.data&&res.data.data.errorList && res.data.data.errorList.length > 0){
          let msg = ''
          res.data.data.errorList.forEach((item) =>{
            msg += '<p style="line-height: 22px;">' + item + '</p>'
          })
          this.$message({
            type: 'warning',
            dangerouslyUseHTMLString: true,
            message: msg,
            duration: 0,
            showClose: true
          });
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    dateFormat: function (row) {
      if (row.installFinishTime !== null && row.installFinishTime !== undefined) {
        return moment(row.installFinishTime).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    closeDialog(){
      this.dialogSubmit = false;
      this.dialogForm.settlementBatchName=''
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}
.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
.submit_btn {
  margin-bottom: 10px;
}
::v-deep .el-message .el-message__content{
  line-height: 22px !important;
}
</style>
